// DEPENDENCIES
import axios from 'axios';
import { replace } from 'react-router-redux';
import { browserHistory } from 'react-router';

import { isEmpty } from 'lodash';

// INNER IMPORTS
import { connection } from '../Config/Settings';
import { getDatatypes } from "./main";

export const BE_USER_REQUEST                  = 'BE_USER_REQUEST';
export const BE_USER_SUCCESS                  = 'BE_USER_SUCCESS';
export const BE_USER_FAILURE                  = 'BE_USER_FAILURE';

export const GET_ADMIN_PINS_REQUEST           = 'GET_ADMIN_PINS_REQUEST';
export const GET_ADMIN_PINS_SUCCESS           = 'GET_ADMIN_PINS_SUCCESS';
export const CLEAR_ADMIN_PINS                 = 'CLEAR_ADMIN_PINS';
export const GET_ADMIN_PINS_FAILURE           = 'GET_ADMIN_PINS_FAILURE';

export const SET_ADMIN_PIN_APPROVAL_REQUEST   = 'SET_ADMIN_PIN_APPROVAL_REQUEST';
export const SET_ADMIN_PIN_APPROVAL_SUCCESS   = 'SET_ADMIN_PIN_APPROVAL_SUCCESS';
export const SET_ADMIN_PIN_APPROVAL_FAILURE   = 'SET_ADMIN_PIN_APPROVAL_FAILURE';

export const SAVE_SETTINGS_REQUEST            = 'SAVE_SETTINGS_REQUEST';
export const SAVE_SETTINGS_SUCCESS            = 'SAVE_SETTINGS_SUCCESS';
export const SAVE_SETTINGS_FAILURE            = 'SAVE_SETTINGS_FAILURE';

export const SAVE_BANNER_REQUEST              = 'SAVE_BANNER_REQUEST';
export const SAVE_BANNER_SUCCESS              = 'SAVE_BANNER_SUCCESS';
export const SAVE_BANNER_FAILURE              = 'SAVE_BANNER_FAILURE';

export const UPGRADE_REQUEST                  = 'UPGRADE_REQUEST';
export const UPGRADE_SUCCESS                  = 'UPGRADE_SUCCESS';
export const UPGRADE_FAILURE                  = 'UPGRADE_FAILURE';

export const OPEN_BANNER_MODAL                = 'OPEN_BANNER_MODAL';
export const CLOSE_BANNER_MODAL               = 'CLOSE_BANNER_MODAL';


export const GET_ALL_TRANSACTIONS_SUCCESS     = 'GET_ALL_TRANSACTIONS_SUCCESS';
export const GET_ALL_TRANSACTIONS_FAILURE     = 'GET_ALL_TRANSACTIONS_FAILURE';

export const ANALYTICS_DISABLE_TOGGLE_REQUEST     = 'ANALYTICS_DISABLE_TOGGLE_REQUEST';
export const ANALYTICS_DISABLE_TOGGLE_SUCCESS     = 'ANALYTICS_DISABLE_TOGGLE_SUCCESS';
export const ANALYTICS_DISABLE_TOGGLE_FAILURE     = 'ANALYTICS_DISABLE_TOGGLE_FAILURE';

export const PINS_VIEWS_COUNT_INC_REQUEST     = 'PIN_VIEWS_COUNT_INC_REQUEST';
export const PINS_VIEWS_COUNT_INC_SUCCESS     = 'PIN_VIEWS_COUNT_INC_SUCCESS';
export const PINS_VIEWS_COUNT_INC_FAILURE     = 'PIN_VIEWS_COUNT_INC_FAILURE';

export const TOGGLE_UNLIMITED_PINS_REQUEST     = 'TOGGLE_UNLIMITED_PINS_REQUEST';
export const TOGGLE_UNLIMITED_PINS_SUCCESS     = 'TOGGLE_UNLIMITED_PINS_SUCCESS';


export function saveDatatypesRequest(datatypes) {
    return {
        type: 'SAVE_DATATYPES_REQUEST',
        datatypes: datatypes
    }
}

export function saveDatatypesSuccess(response) {
    return {
        type: 'SAVE_DATATYPES_SUCCESS',
        datatypes: response.data
    }
}

export function saveDatatypesFailure(err) {
    return {
        type: 'SAVE_DATATYPES_FAILURE',
        error: err
    }
}

export function getAllUsersRequest() {
    return {
        type: 'GET_ALL_USERS_REQUEST'
    }
}

export function getAllUsersSuccess(response) {
    return {
        type: 'GET_ALL_USERS_SUCCESS',
        data: response.data,
    }
}

export function getAllUsersFailure(err) {
    return {
        type: 'GET_ALL_USERS_FAILURE',
        error: err
    }
}

export function getAllTransactionsSuccess(res) {
    return {
        type: GET_ALL_TRANSACTIONS_SUCCESS,
        data: res.data
    }
}

export function getAllTransactionsFailure(err) {
    return {
        type: GET_ALL_TRANSACTIONS_FAILURE,
        error: err
    }
}

export function deactivateRequest() {
    return {
        type: 'DEACTIVATE_REQUEST'
    }
}

export function deactivateSuccess(response) {
    return {
        type: 'DEACTIVATE_SUCCESS',
        users: response.data
    }
}

export function deactivateFailure(err) {
    return {
        type: 'DEACTIVATE_FAILURE',
        error: err
    }
}

export function activateRequest() {
    return {
        type: 'ACTIVATE_REQUEST'
    }
}

export function activateSuccess(response) {
    return {
        type: 'ACTIVATE_SUCCESS',
        users: response.data
    }
}

export function activateFailure(err) {
    return {
        type: 'ACTIVATE_FAILURE',
        error: err
    }
}

export const beUserRequest = () => ({
    type: BE_USER_REQUEST
});

export const beUserSuccess = (response) => ({
    type: BE_USER_SUCCESS,
    response
});

export const beUserFailure = (error) => ({
    type: BE_USER_FAILURE,
    error
});

export const getADminPinsRequest = () => ({
    type: GET_ADMIN_PINS_REQUEST
});

export const getAdminPinsSuccess = (response) => ({
    type: GET_ADMIN_PINS_SUCCESS,
    response
});

export const clearAdminPins = () => ({
    type: CLEAR_ADMIN_PINS
});
export const getAdminPinsFailure = (error) => ({
    type: GET_ADMIN_PINS_FAILURE,
    error
});

export const setAdminPinStatusRequest = () => ({
    type: SET_ADMIN_PIN_APPROVAL_REQUEST
});

export const setAdminPinStatusSuccess = (response) => ({
    type: SET_ADMIN_PIN_APPROVAL_SUCCESS,
    response
});

export const setAdminPinStatusFailure = (error) => ({
    type: SET_ADMIN_PIN_APPROVAL_FAILURE,
    error
});

export const saveSettingsRequset = () => ({
    type: SAVE_SETTINGS_REQUEST
});

export const saveSettingsSuccess = (response, settings) => ({
    type: SAVE_SETTINGS_SUCCESS,
    response,
    settings
});

export const saveSettingsFailure = (error) => ({
    type: SAVE_SETTINGS_FAILURE,
    error
});

export const closeBannerModal = () => ({
    type: CLOSE_BANNER_MODAL
});

export const openBannerModal = (bannerType, bannerIndex) => ({
    type: OPEN_BANNER_MODAL,
    bannerIndex,
    bannerType
});

export const saveBannerRequest = () => ({
    type: SAVE_BANNER_REQUEST
});

export const saveBannerSuccess = (response) => ({
    type: SAVE_BANNER_SUCCESS,
    response,
});

export const saveBannerFailure = (error) => ({
    type: SAVE_BANNER_FAILURE,
    error
});

export const upgradeRequest = () => ({
    type: UPGRADE_REQUEST
});

export const upgradeSuccess = (response) => ({
    type: UPGRADE_SUCCESS,
    response,
});

export const upgradeFailure = (error) => ({
    type: UPGRADE_FAILURE,
    error
});

export const toggleAnalyticsDisableRequest = () => ({
    type: ANALYTICS_DISABLE_TOGGLE_REQUEST
})

export const toggleAnalyticsDisableSuccess = (userId, isAnalyticsDisabled) => ({
    type: ANALYTICS_DISABLE_TOGGLE_SUCCESS,
    isAnalyticsDisabled,
    userId
})

export const toggleAnalyticsDisableFailure = () => ({
    type: ANALYTICS_DISABLE_TOGGLE_FAILURE
})

export const incPinsViewRequest = () => ({
    type: PINS_VIEWS_COUNT_INC_REQUEST
})

export const incPinsViewSuccess = () => ({
    type: PINS_VIEWS_COUNT_INC_SUCCESS
})

export const incPinsViewFailure = error => ({
    type: PINS_VIEWS_COUNT_INC_FAILURE,
    error
})

export const toggleUnlimitedPinsRequest = () => ({
    type: TOGGLE_UNLIMITED_PINS_REQUEST
});

export const toggleUnlimitedPinsSuccess = (userId, isUnlimitedPins) => ({
    type: TOGGLE_UNLIMITED_PINS_SUCCESS,
    userId,
    isUnlimitedPins
});

///////// Thunk async api requests //////////////
export const getAdminPins = (token, query) => {
    return (dispatch) => {
        dispatch(getADminPinsRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        axios.post(connection().serverUrl + '/api/admin/pins', query, config)
            .then(res => {
                dispatch(getAdminPinsSuccess(res));
            })
            .catch(err => {
                dispatch(getAdminPinsFailure(err));
                browserHistory.replace('/')
            })
    }
};

export const upgradeEnrollType = (token, query, payload) => {
    return (dispatch) => {
        dispatch(upgradeRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        axios.post(connection().serverUrl + '/api/admin/upgrade', payload , config)
            .then(res => {
                dispatch(upgradeSuccess(res));
                dispatch(getAdminPins(token, query))
            })
            .catch(err => {
                dispatch(upgradeFailure(err));
            })
    }
};

export const saveSettings = (token, settings) => {
    return dispatch => {
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        dispatch(saveSettingsRequset());
        axios.post(connection().serverUrl + '/api/admin/settings', { settings }, config)
            .then(res => {
                dispatch(saveSettingsSuccess(res, settings));
                alert('Settings were successfully saved')
            }, err => {
                dispatch(saveSettingsFailure(err));
                browserHistory.replace('/')
            })
    }
};

export const setAdminPinStatus = (token, data) => {
    return (dispatch) => {
        dispatch(setAdminPinStatusRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        axios.post(connection().serverUrl + '/api/admin/set-pin', data, config)
            .then(res => {
                dispatch(setAdminPinStatusSuccess(res));
                dispatch(getAdminPins(token, {type: data.type}))
            })
            .catch(err => {
                dispatch(setAdminPinStatusFailure(err));
                browserHistory.replace('/')
            })
    }
};

export const beUser = (token, userId) => {
    return (dispatch) => {
        dispatch(beUserRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        axios.post(connection().serverUrl + "/api/admin/be-user", { userId }, config).then((res) => {
            dispatch(beUserSuccess(res));
            dispatch(replace('/'))
        }).catch((err)=> {
            dispatch(beUserFailure(err));
        })
    }
};

export function createTempUserCall(token, data) {
    return dispatch => {
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        return axios.post(connection().serverUrl + "/api/users/a-create-user", data, config)
            .then(res => Promise.resolve())
            .catch(err => Promise.reject(err));
    }
}

export function getAllUsers(token, { startDate, endDate, userEmail, isOnlyTmpUsers }) {
    return (dispatch) => {
        dispatch(getAllUsersRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        const data = { startDate, endDate, userEmail, isOnlyTmpUsers };

        axios.post(connection().serverUrl + "/api/admin/get-all-users", data, config).then((res) => {
            dispatch(getAllUsersSuccess(res));
        }).catch((err)=> {
            dispatch(getAllUsersFailure(err));
            dispatch(replace('/'))
        })
    }
}

export function getAllTransactions(token, query) {
    return (dispatch) => {
        dispatch(getAllUsersRequest());
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        axios.post(connection().serverUrl + "/api/admin/get-all-transactions", query, config).then((res) => {
            if (!res || !res.data) return;
            dispatch(getAllTransactionsSuccess(res));
        }).catch((err)=> {
            dispatch(getAllTransactionsFailure(err));
            dispatch(replace('/'))
        })
    }
}

export function saveDatatypes(token, datatypes, files, type, catName, catIndex) {
    return (dispatch) => {
        dispatch(saveDatatypesRequest(datatypes));
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'content-type': 'application/json'
            }
        };

        // no images were changed by the user
        if (isEmpty(files)) {
            return axios.post(connection().serverUrl + "/api/admin/saveDatatypes", { datatypes, catIndex }, config)
                .then((res) => {
                    dispatch(saveDatatypesSuccess(res));
                }, err => {
                    dispatch(saveDatatypesFailure(err))
                })
        }

        let formData = new FormData();

        for (let f in files) {
            if (files.hasOwnProperty(f)) {
                formData.append('images', files[f]);
                formData.append('type', f);
            }
        }

        // setting content type for file uploading
        config.headers['content-type'] = 'multipart/form-data';

        // cat name should be checked for duplication
        return axios.post(connection().serverUrl + "/api/admin/upload-category-svgs?cat=" + catName, formData, config)
            .then((res)=> {
                // in case this is a new category
                if (catIndex === -1) {
                    catIndex = datatypes.categories[type].length -1;
                    datatypes.categories[type][catIndex].images = res.data;
                } else {
                    // check each uploaded image, if its on the old images object in the datatypes, replace it
                    res.data.forEach(d => {
                        if (datatypes.categories[type][catIndex].images[d.imageType]) {
                            datatypes.categories[type][catIndex].images[d.imageType] = d
                        }
                    });
                }

                // set headers back for json data
                config.headers['content-type'] = 'application/json';

                return axios.post(connection().serverUrl + "/api/admin/saveDatatypes", { datatypes, catIndex }, config).then((res) => {
                    dispatch(saveDatatypesSuccess(res));
                }, (err) => {
                    dispatch(saveDatatypesFailure(err))
                })
            }, err => {
                if (err.response.status >= 400 && err.response.status < 500) {
                    dispatch(replace('/'))
                }
            })
    }
}

export const saveMobileBanner = (bannerTypes, platform = 'mobile') => {
    return (dispatch, getState) => {
        const { users } = getState();

        if (!users || !users.token) return;

        const config = {
            headers: {
                'Authorization': 'Bearer ' + users.token,
                'content-type': 'application/json'
            }
        };

        return axios.post(connection().serverUrl + "/api/admin/mobile-banners", { platform, ...bannerTypes }, config)
            .then((res) => {
                dispatch(getDatatypes())
                alert('Banner settings saved!');
            })
            .catch(err => {
                console.log('failed updating banner settings', err)
            })
    }
}

export const saveBannerSettings = (token, { videoUrl, type }) => {
    return dispatch => {
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'content-type': 'application/json'
            }
        };

        return axios.post(connection().serverUrl + "/api/admin/banner-settings", { videoUrl, type }, config)
            .then((res) => {
                alert('Banner settings saved!');
            })
            .catch(err => {
                console.log('failed updating banner settings', err)
            })
    }
};

export const saveBanner = (datatypes, banners, bannerPlatform = 'mobile') => {
    return (dispatch, getState) => {
        dispatch(saveBannerRequest(datatypes));

        const { users } = getState();

        if (!users || !users.token) return;

        const config = {
            headers: {
                'Authorization': 'Bearer ' + users.token,
                'content-type': 'application/json'
            }
        };

        if (!banners || banners.length < 1) return console.log('banners are empty', banners)

        const bannerPromises = [];

        banners.forEach(files => {
            const formData = new FormData();

            for (let f in files) {
                if (files.hasOwnProperty(f)) {
                    formData.append('images', files[f]);
                    formData.append('type', f);
                    if (files[f] && files[f].cat) formData.append('cat', files[f].cat)
                }
            }

            // setting content type for file uploading
            config.headers['content-type'] = 'multipart/form-data';
            bannerPromises.push(axios.post(`${connection().serverUrl}/api/admin/upload-banner-images?p=${bannerPlatform}`, formData, config));
        })

        Promise.all(bannerPromises)
            .then(resArr => {
                if (!resArr || resArr.length < 1) return console.log('Banner Promises are empty');

                const links = [];
                resArr.forEach(res => links.push(res.data));
                return Promise.resolve(links || []);
            })
            .then(links => {
                dispatch(saveBannerSuccess());
            })
            .catch(err => {
                console.log('One of the image upload failed: ', err);
                dispatch(saveBannerFailure(err));
            });

        // setting content type for file uploading
        config.headers['content-type'] = 'multipart/form-data';
    }
};

export function deactivate(token, userid) {
    return (dispatch) => {
        dispatch(deactivateRequest(userid));
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        return axios.post(connection().serverUrl + "/api/admin/deactivate", {userid: userid}, config).then((res) => {
            dispatch(deactivateSuccess(res));
        }).catch((err)=> {
            dispatch(deactivateFailure(err))
        })
    }
}

export function activate(token, userid) {
    return (dispatch) => {
        dispatch(activateRequest(userid));
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        return axios.post(connection().serverUrl + "/api/admin/activate", {userid: userid}, config).then((res) => {
            dispatch(activateSuccess(res));
        }).catch((err)=> {
            dispatch(activateFailure(err));
        });
    }
}

export function toggleAnalyticsDisable(userId) {
    return (dispatch, getState) => {
        const { users } = getState()

        if (!users || !users.token || !userId) return;

        dispatch(toggleAnalyticsDisableRequest());

        let config = {
            headers: {
                'Authorization': 'Bearer ' + users.token
            }
        };

        return axios.post(connection().serverUrl + "/api/admin/ta", { userId }, config).then((res) => {
            if (!res || !res.data) throw new Error('No body response');
            dispatch(toggleAnalyticsDisableSuccess(userId, res.data.isAnalyticsDisabled));
        }).catch((err)=> {
            dispatch(toggleAnalyticsDisableFailure(err))
        })
    }
}

export function incPinsView(pinsType, rangeMin, rangeMax) {
    return (dispatch, getState) => {
        const { users } = getState()

        if (!users || !users.token) return;

        let config = {
            headers: {
                'Authorization': 'Bearer ' + users.token
            }
        };

        dispatch(incPinsViewRequest());

        return axios.post(connection().serverUrl + "/api/admin/pinc", { pinsType, rangeMin, rangeMax }, config).then((res) => {
            if (!res || !res.data) throw new Error('No body response');

            dispatch(incPinsViewSuccess());
        }).catch((err)=> {
            dispatch(incPinsViewFailure(err));
        })
    }
}

export function toggleRepeat(pin) {
    return (dispatch, getState) => {
        const { users } = getState()

        if (!users || !users.token) return;

        let config = {
            headers: {
                'Authorization': 'Bearer ' + users.token
            }
        };

        return axios.post(`${connection().serverUrl}/api/admin/toggle-repeat`, { pinId: pin._id }, config)
            .then(res => {
                if (!res) throw new Error(`No response from server`);

                if (res.status !== 200) throw new Error(`Failed with [${res.status}]`)

                dispatch(getAdminPins(users.token));

            })
            .catch (err => {
                console.log('Failed toggling repeat: ', err);
            })
    }
}


export function manualUpdateSitemap() {
    return (dispatch, getState) => {
        const { users } = getState()

        if (!users || !users.token) return;

        let config = {
            headers: {
                'Authorization': 'Bearer ' + users.token
            }
        };

        return axios.get(`${connection().serverUrl}/api/admin/seo`, config)
            .then(res => {
                if (!res) throw new Error(`No response from server`);

                if (res.status !== 200) throw new Error(`Failed with [${res.status}]`)

                alert('Sitemap file was updated successfully')
            })
            .catch (err => {
                console.log('Failed toggling repeat: ', err);
                alert('Failed updating sitemap file')
            })
    }
}

export const toggleUnlimitedPins = userId => {
    return (dispatch, getState) => {
        const { users } = getState()

        if (!users || !users.token) return;

        let config = {
            headers: {
                'Authorization': 'Bearer ' + users.token
            }
        };

        dispatch(toggleUnlimitedPinsRequest());

        return axios.post(`${connection().serverUrl}/api/admin/un-p`, { userId }, config)
            .then(res => {
                if (!res || !res.data) throw new Error(`No response from server`);

                if (res.status !== 200) throw new Error(`Failed with [${res.status}]`);

                dispatch(toggleUnlimitedPinsSuccess(userId, res.data.isUnlimitedPins))

                alert(`${res.data.isUnlimitedPins ? 'User can now upload unlimited Ads' : 'User now limited to Basic Ads limit'}`)
            })
            .catch (err => {
                console.log('Failed toggling repeat: ', err);
                alert('Failed updating sitemap file')
            })
    }
}





// WEBPACK FOOTER //
// ./src/Actions/admin.js